import axios from './http'

export default {
    getAll(){
        return axios.get('/v1/pricetype')
        .then(function (response) {
            // console.log(response)
            return Promise.resolve(response.data)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
    }
}